import { InvalidParamError } from './invalid-param-error';

/**
 * Serialized and sent to us as "[start-end]", where start >= 0.
 */
export type RangeParams = {
  start: number;
  end: number;
};

export class RangeParamError extends InvalidParamError {
  constructor(error: string) {
    super('did not understand range parameter: ' + error);
  }
}

export const deserializeRangeParams = (params: string): RangeParams => {
  const pattern = /^\[([0-9]+),([0-9]+)\]$/g;

  // Expect result to be: [[params (the input), start, end]]
  const result = Array.from(params.matchAll(pattern));

  if (result.length === 0) {
    throw new RangeParamError(`invalid format: ${params}`);
  }

  if (result[0].length !== 3) {
    throw new RangeParamError(`length = ${result.length} !== 3`);
  }

  const start = Number(result[0][1]);
  const end = Number(result[0][2]);

  if (Number.isNaN(start) || Number.isNaN(end)) {
    throw new RangeParamError(`a value is NaN: ${result[0].toString()}`);
  }

  return {
    start,
    end,
  };
};
